import { createNode } from '@glueapp/graph-types';

export const DynamicGetSecret = createNode({
    id: 'Dynamic Get Secret',
    name: 'Dynamic Get Secret',
    description: 'Retrieves a secret by name from a curated set of available secrets',
    aiDescription: [
        'Retrieves a secret by dynamic name lookup at runtime.',
        'Unlike "Get Secret" which selects a fixed secret, this node takes a secret name as a string',
        'input and looks it up from a curated set configured via the UI (dynamic-secret-selector).',
        '',
        'Input: "Secret Name" (string) — the name of the secret to retrieve.',
        'Output: "Value" (string) — the resolved secret value (empty string if not found).',
        'Output: "Found" (boolean) — whether the secret name was found in the available set.',
        '',
        "The available secrets are configured via the node's interface component and stored in",
        'state.resolvedSecretMap. At execution time, the input name is looked up in that map.',
    ].join('\n'),
    category: 'Secrets',
    color: '#e6a817',
    interfaceComponentId: 'dynamic-secret-selector',
    inPorts: {
        'Secret Name': { kind: 'string' },
    },
    outPorts: {
        Value: { kind: 'string' },
        Found: { kind: 'boolean' },
    },
    execute(input) {
        const name = input.inPorts['Secret Name'] as string;
        const resolvedMap = (input.state.resolvedSecretMap || {}) as Record<string, string>;
        const value = resolvedMap[name];
        return {
            output: {
                Value: value ?? '',
                Found: value !== undefined,
            },
        };
    },
});
